import React from "react";
import MuiCheckbox, { CheckboxProps } from "@material-ui/core/Checkbox";

const Checkbox: React.FC<CheckboxProps> = props => {
  return <MuiCheckbox {...props} />;
};

export default Checkbox;
